(function ($) {
    // Cache selectors to avoid repeated DOM queries
    var $window = $(window);
    var $document = $(document);
    
    // Debounce function to limit execution rate
    function debounce(func, wait) {
        var timeout;
        return function executedFunction() {
            var context = this;
            var args = arguments;
            var later = function() {
                timeout = null;
                func.apply(context, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
    
    // Initialize carousel with optimized settings
    function initCarousel() {
        var $carousel = $(".featured-research-carousel .row-wrap");
        
        // Early exit if already initialized
        if ($carousel.hasClass('slick-initialized')) {
            return;
        }
        
        var $cardWrapper = $(".featured-research-carousel .card-wrapper");
        
        if ($cardWrapper.length > 2) {
            // Hide tenor gif embed
            $(".featured-research-carousel .tenor-gif-embed").css("display", "none");
            $(".featured-research-carousel .row-wrap").css("opacity", "1");
            
            // Initialize slick with optimized settings
            $carousel.slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                autoplay: false,
                speed: 2000,
                infinite: true,
                lazyLoad: 'ondemand', 
                responsive: [{
                    breakpoint: 1270,
                    settings: {
                        slidesToShow: 2.3,
                    },
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1.2,
                        infinite: true,
                    },
                }]
            });
            
            // Optimize arrow positioning
            var $introBlock = $(".featured-research-carousel .intro-block h4");
            if ($introBlock.length) {
                var leftForArrow = $introBlock.outerWidth() + 16;
                var $slickPrev = $(".featured-research-carousel .slick-arrow");
                var $slickNext = $(".featured-research-carousel .slick-next");
                
                $slickPrev.css("left", leftForArrow);
                $slickNext.css("left", leftForArrow + 44);
            }
            
            // Event delegation with namespace for better cleanup
            $document.off('click.featuredCarouselPrev click.featuredCarouselNext')
                .on('click.featuredCarouselPrev', ".featured-research-carousel .slick-prev", function() {
                    if (window.dataLayer) {
                        dataLayer.push({
                            event: 'featured_carousel_slider_arrow_click',
                            event_category: 'Featured Carousel Slider Arrow Click',
                            event_label: 'Featured Carousel Slider Previous Arrow',
                            page_url: window.location.pathname
                        });
                    }
                })
                .on('click.featuredCarouselNext', ".featured-research-carousel .slick-next", function() {
                    if (window.dataLayer) {
                        dataLayer.push({
                            event: 'featured_carousel_slider_arrow_click',
                            event_category: 'Featured Carousel Slider Arrow Click',
                            event_label: 'Featured Carousel Slider Next Arrow',
                            page_url: window.location.pathname
                        });
                    }
                })
                .off('click.featuredCarouselCard')
                .on('click.featuredCarouselCard', ".featured-research-carousel .card-wrapper", function() {
                    if (window.dataLayer) {
                        var $this = $(this);
                        var cardTitle = $this.find("h4").text().trim();
                        var pageUrl = $this.find("a").attr("href");
                        dataLayer.push({
                            event: 'fellows_featured_research',
                            event_label: cardTitle,
                            link_url: pageUrl
                        });
                    }
                });
        }
    }
    
    // Optimized image loading removal
    function removeImageLoading() {
        var $carouselImages = $('.featured-research-carousel .card-img img');
        if ($carouselImages.length) {
            $carouselImages.removeAttr('loading');
        }
    }
    
    // Initialize dotdotdot with requestAnimationFrame for better performance
    function initDotDotDot() {
        if ($.fn.dotdotdot) {
            // Use requestAnimationFrame to avoid blocking main thread
            requestAnimationFrame(function() {
                $(".js_featured_research_publishedworkbyfellows .featured-research-carousel h4").dotdotdot({
                    height: 86,
                    fallbackToLetter: true,
                    watch: true
                });
                
                $("body .featured-research-carousel .author-detail .editor").dotdotdot({
                    height: 25,
                    fallbackToLetter: true,
                    watch: true
                });
            });
        }
    }
    
    // Add no-title class
    function addNoTitleClass() {
        $('.featured-research-carousel').each(function() {
            var $section = $(this);
            var $introBlock = $section.find('.intro-block');
            if ($introBlock.find('h4').length === 0 && !$section.hasClass('no-title')) {
                $section.addClass('no-title');
            }
        });
    }
    
    // Combined initialization function
    function initializeAll() {
        // Check if carousel exists
        if ($('.js_featured_carousel_events, .featured-research-carousel').length) {
            initCarousel();
        }
        initDotDotDot();
        addNoTitleClass();
    }
    
    // Use Intersection Observer for lazy initialization (if supported)
    if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    initializeAll();
                    observer.disconnect(); // Only initialize once
                }
            });
        }, { threshold: 0.1 });
        
        var targetElement = document.querySelector('.featured-research-carousel');
        if (targetElement) {
            observer.observe(targetElement);
        } else {
            // Fallback if element not found
            $window.on('load', initializeAll);
        }
    } else {
        // Fallback for older browsers
        $window.on('load', initializeAll);
    }
    
    // Optimized resize handler with debouncing
    var resizeTimeout;
    $window.on("resize orientationchange", debounce(function() {
        // Only reinitialize if carousel exists and is visible
        var $carousel = $(".featured-research-carousel .row-wrap");
        if ($carousel.length && $carousel.is(':visible')) {
            // Update arrow positions without reinitializing
            var $introBlock = $(".featured-research-carousel .intro-block h4");
            if ($introBlock.length) {
                var leftForArrow = $introBlock.outerWidth() + 16;
                $(".featured-research-carousel .slick-arrow").css("left", leftForArrow);
                $(".featured-research-carousel .slick-next").css("left", leftForArrow + 44);
            }
            
            // Refresh slick on resize
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('refresh');
            }
        }
    }, 150));
    
    // Run initialization after DOM is ready
    $(document).ready(function() {
        // Use setTimeout with 0 to defer execution
        setTimeout(function() {
            if ($('.js_featured_carousel_events, .featured-research-carousel').length) {
                removeImageLoading();
            }
        }, 0);
    });
    
})(jQuery);